module.exports = __webpack_public_path__ + "img/eye.8fcb104e.svg";